<template>
   <div
    id="lm-button-root-wrapper"
    class="form-group row"
    :class="[
      lmButtonRootWrapperClass,
      {'avoid-pointer-events': this.isProcessing}
      ]"
    >
    <div
      id="lm-button-wrapper"
      :class="[
          lmButtonWrapperClass,
          {'col-sm-10':!lmButtonWrapperClass}
        ]"
      >
      <button
        id="lm-button"
        ref="lmButton"
        :type="type"
        :disabled="disabled || isProcessing"
        :style="{width: buttonWidth, height: buttonHeight}"
        :class="[
          buttonClass,
          {'btn-info': !buttonClass && !disabled},
          {disabled: disabled}
        ]"
        class="btn d-flex justify-content-center"
        >
          <LmSpinnerBorder v-if="isProcessing"/>
          {{text}}
        </button>
    </div>
    <b-tooltip v-if="showTooltip" target="lm-button-wrapper" placement="top">
      {{tooltip.value}}
    </b-tooltip>
  </div>
</template>

<script>
import LmSpinnerBorder from '@/components/LmSpinnerBorder'
export default {
  data () {
    return {
      buttonWidth: null,
      buttonHeight: null
    }
  },
  computed: {
    showTooltip () {
      if (this.tooltip) {
        if (this.tooltip.showOnlyOnDisabled && this.tooltip.value) {
          return this.disabled
        } else {
          return this.tooltip.value
        }
      }
    },
    text () {
      return this.isProcessing ? '' : this.value
    }
  },
  props: {
    value: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    buttonClass: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    tooltip: {
      type: Object
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    lmButtonWrapperClass: {
      type: String
    },
    lmButtonRootWrapperClass: {
      type: String
    }
  },
  components: {
    LmSpinnerBorder
  },
  mounted () {
    this.buttonWidth = `${this.$refs.lmButton.offsetWidth}px`
    this.buttonHeight = `${this.$refs.lmButton.offsetHeight}px`
  }
}
</script>
<style lang="sass" scoped>
  .btn
    white-space: nowrap
</style>
